import React from "react";

const TalksIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg viewBox="0 0 66 66" fill="none" {...props}>
    <g filter="url(#filter0_d_10457_1715)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20.687C10 14.443 14.436 10 20.669 10h24.384c6.234 0 10.67 4.443 10.67 10.687v25.188c0 5.48-4.437 9.923-9.908 9.923H19.907c-5.472 0-9.907-4.443-9.907-9.923V20.687z"
        fill="url(#paint0_linear_10457_1715)"
      />
    </g>
    <path
      d="M22.996 23.5a4.5 4.5 0 014.5-4.5h15a4.5 4.5 0 014.5 4.5v10a4.5 4.5 0 01-4.5 4.5h-6.309c-.6-1.316-1.876-2.17-3.192-2.422V34a3 3 0 013-3h5a3 3 0 013 3v1.5a2.496 2.496 0 001.001-2v-10a2.5 2.5 0 00-2.5-2.5h-15a2.5 2.5 0 00-2.5 2.5v.314c-.724.234-1.4.593-2 1.062V23.5zm18 9.5h-5a1 1 0 00-1 1v2h7v-2a1 1 0 00-1-1zm-6.586 5a2.549 2.549 0 01.627 1.873c-.135 2.074-.918 3.68-2.403 4.728C31.201 45.612 29.257 46 26.995 46c-2.248 0-4.156-.384-5.566-1.386-1.458-1.037-2.228-2.619-2.417-4.65C18.85 38.218 20.345 37 21.867 37h10.32a2.982 2.982 0 012.223 1zm-12.542 1c-.585 0-.897.43-.865.78.15 1.603.713 2.584 1.584 3.204.92.653 2.335 1.016 4.408 1.016 2.086 0 3.543-.368 4.486-1.033.89-.628 1.455-1.617 1.56-3.223.022-.333-.283-.744-.855-.744H21.868zm20.127-12.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm-2 0a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm-8 3.5a5 5 0 11-10 0 5 5 0 0110 0zm-2 0a3 3 0 10-6 0 3 3 0 006 0z"
      fill="#8065C9"
    />
    <defs>
      <filter
        id="filter0_d_10457_1715"
        x={0}
        y={0}
        width={65.7227}
        height={65.7979}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10457_1715"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_10457_1715"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10457_1715"
        x1={10}
        y1={10}
        x2={10}
        y2={55.798}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#E8E8E8" />
      </linearGradient>
    </defs>
  </svg>
);

export default TalksIcon;
